var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-page md-layout md-alignment-center-center" },
    [
      _c(
        "form",
        {
          staticClass:
            "auth-page__form md-layout md-layout-item md-alignment-center-center",
          attrs: { novalidate: "" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "md-card",
            {
              staticClass:
                "auth-page__card md-layout-item md-size-30 md-large-size-45 md-medium-size-55 md-small-size-75 md-xsmall-size-100"
            },
            [
              _vm.isPending
                ? _c("md-progress-bar", {
                    attrs: { "md-mode": "indeterminate" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("md-card-header", [
                _c("div", { staticClass: "text_xl_large" }, [
                  _vm._v(_vm._s(_vm.i18n.log_signin()))
                ])
              ]),
              _vm._v(" "),
              _c(
                "md-card-content",
                [
                  _vm.form.email.trim().length === 0 &&
                  _vm.verifyEmailParams &&
                  _vm.verifyEmailParams.email.length > 0
                    ? _c("input-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "input-field",
                        attrs: {
                          id: "login-email",
                          label: _vm.i18n.lbl_email(),
                          name: "email",
                          errorMessage: _vm.errorMessage("email")
                        },
                        model: {
                          value: _vm.verifyEmailParams.email,
                          callback: function($$v) {
                            _vm.$set(_vm.verifyEmailParams, "email", $$v)
                          },
                          expression: "verifyEmailParams.email"
                        }
                      })
                    : _c("input-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "input-field",
                        attrs: {
                          id: "login-email",
                          label: _vm.i18n.lbl_email(),
                          name: "email",
                          errorMessage: _vm.errorMessage("email"),
                          autocomplete: true
                        },
                        model: {
                          value: _vm.form.email,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "email", $$v)
                          },
                          expression: "form.email"
                        }
                      }),
                  _vm._v(" "),
                  _c("input-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "input-field",
                    attrs: {
                      id: "login-password",
                      type: "password",
                      togglePassword: true,
                      label: _vm.i18n.lbl_pwd(),
                      name: "password",
                      errorMessage: _vm.errorMessage("password"),
                      "data-vv-as": _vm.i18n.signup_password(),
                      autocomplete: true
                    },
                    model: {
                      value: _vm.form.password,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.form,
                          "password",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.password"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "auth-page__bottom" }, [
                    _c("div", { staticClass: "auth-page__tips" }, [
                      _c(
                        "div",
                        { staticClass: "tips__tip text_small" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.i18n.log_dont_have_an_account()) +
                              "\n              "
                          ),
                          _c(
                            "router-link",
                            { attrs: { to: { name: "signup" } } },
                            [_vm._v(_vm._s(_vm.i18n.log_register_now()))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tips__tip text_small" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.i18n.log_forgot_password()) +
                              "\n              "
                          ),
                          _c(
                            "router-link",
                            { attrs: { to: { name: "recovery" } } },
                            [_vm._v(_vm._s(_vm.i18n.log_recover_it()))]
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn-wrap margin-top" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary btn md-yellow w-100",
                          attrs: { type: "submit", disabled: _vm.isPending }
                        },
                        [_vm._v(_vm._s(_vm.i18n.log_signin()))]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.config.FEATURE_FLAGS.tfa
                    ? _c("Tfa", {
                        ref: "qrForm",
                        staticClass: "security-settings__tfa-settings",
                        on: { enterApplication: _vm.enterApplication }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33023a38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33023a38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/auth/Login.vue
// module id = LtU5
// module chunks = 1